import React, { useState, useEffect } from "react";
import { Button, Groupper, Header, Input, Message, useFrontier } from "react-frontier2";
import { SetLoading } from "@arema/components/Classes";
import { bindFormChange } from "@arema/components/Util";
import { DeletedBanner, NotFound } from "../../components";
import { useUser } from "../../AdminHooks";
import { Zone } from '../../AdminClasses';
import API from "../../API";
import Validator from "@arema/components/Validator";
import UserAccess from "../../UserAccess";

interface Props {
	zone_id?: string,
	zone?: Zone,
}

const ZoneView = (props: Props)=>{
	var { Toast } = useFrontier();
	var { hasAccess } = useUser();
	var [zone, setZone] = useState<Zone>(null);
	var [errorPrompts, setErrorPrompts] = useState<string[]>(null);
	var zone_id = Number.isNaN(parseInt(props.zone_id)) ? null : parseInt(props.zone_id);
	var can_edit = hasAccess(UserAccess.CATALOGS.ZONES_EDIT);

	useEffect(()=>{
		setZone(props.zone || {
			zone_id,
			zone_name: '',
			description: null,
		});
	}, [props.zone]);

	const submit = async (setLoading: SetLoading)=>{
		if(!can_edit) return;
		var { valid, prompts } = Validator(zone, {
			zone_name: [{
				rule: 'length', params: [4, 64], label: 'Nombre'
			}],
			description: [{
				rule: 'length', params: [4], label: 'Descripcion'
			}],
		});
		setErrorPrompts(prompts);
		if(!valid) return;

		setLoading(true);
		API.editZone(zone.zone_id, zone.zone_name, zone.description).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			Toast.success('Se ha editando la zona');
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado editando la zona (LCL-CLZNVW-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	if(zone_id===null) return <NotFound />
	if(!zone) return <Header text="Cargando zona" loading />

	const onChangeField = bindFormChange(zone, setZone);

	return <>
		{!!zone?.deleted ? <DeletedBanner date_deleted={zone.date_deleted} /> : null}
		<Groupper title={'Editar Zona'} style={{ maxWidth: 500 }} titleRight={`ID: ${zone_id}`} actions={can_edit && (
			<Button text="Guardar" color="black" onClick={submit} />
		)}>
			<Input
				label="Nombre"
				placeholder="Nombre de la Zona"
				value={zone.zone_name}
				readonly={!can_edit}
				onChange={onChangeField('zone_name')}
			/>

			<Input
				label="Descripcion"
				placeholder="Descripcion"
				value={zone.description}
				readonly={!can_edit}
				onChange={onChangeField('description')}
			/>

			<Message list={errorPrompts} type="error" style={{ marginTop: 15 }} />
		</Groupper>
	</>
}

export default ZoneView;